var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstalment3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34103",
    "data-name": "Group 34103",
    transform: "translate(-40 -837.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27137",
    "data-name": "Group 27137",
    transform: "translate(-2 65.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38613",
    "data-name": "Path 38613",
    d: "M.018-3.66c1.512,0,1.788.624,1.788,1.128C1.806-1.632.738-1.3-.066-1.3c-.684,0-1.848-.3-1.848-1.164h-1.6C-3.5-.552-1.674.12-.078.12c1.62,0,3.552-.612,3.552-2.664A1.888,1.888,0,0,0,2.106-4.308,1.672,1.672,0,0,0,3.27-5.964C3.258-7.752,1.554-8.52-.03-8.52c-1.548,0-3.348.66-3.348,2.472h1.584c0-.768,1.008-1.032,1.752-1.032,1.344,0,1.728.636,1.728,1.116-.012.78-.912,1.008-1.764,1.008H-1.29v1.3Z",
    transform: "translate(56 789.947)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    d: "M14,2A12,12,0,0,0,5.515,22.485,12,12,0,1,0,22.485,5.515,11.921,11.921,0,0,0,14,2m0-2A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    transform: "translate(42 772)",
    fill: "#dedede"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalment3);
export default __webpack_public_path__ + "static/media/instalment-3.e09c963c05f6d4b6f3c69ead4f146ceb.svg";
export { ForwardRef as ReactComponent };